import { LandingZoneModel } from "@api/types";
import { httpClient } from "../../httpClient";

type Data = {
  landingZones: LandingZoneModel[];
};

const landingZoneRoute = "/api/v1/landing-zones";

export async function getLandingZones(): Promise<LandingZoneModel[]> {
  try {
    const { data } = await httpClient.get<Data>(landingZoneRoute);

    return data.landingZones;
  } catch (err) {
    throw err;
  }
}

export async function postLandingZone(payload: LandingZoneModel) {
  try {
    const { data } = await httpClient.post(landingZoneRoute, payload);
    return data;
  } catch (err) {
    throw err;
  }
}

export async function putLandingZone(payload: LandingZoneModel) {
  try {
    const { data } = await httpClient.put(landingZoneRoute, payload);
    return data;
  } catch (err) {
    throw err;
  }
}
